import React, {Component} from 'react'
import { connect } from 'react-redux'
import Draggabilly from 'draggabilly'

import RecordButton from './RecordButton';

import Registry from '../../../registry/index';

import * as VirtualWindowManager from '../VirtualWindowManager/index';

import {
    STREAMING_ERROR
} from '../../../constants/streaming';
import BecomeXXLPopup from '../BecomeXXLPopup';

class VideoWindowMine extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ...props.myVideoWindow,
            resolution: null,
            countdownValue: 3,
            showCountdown: false,
            confirmRecord: false,
        };

        this.onMicClick = this.onMicClick.bind(this);
        this.onRecordClick = this.onRecordClick.bind(this);
        this.onPauseClick = this.onPauseClick.bind(this);
        this.onTakeShotClick = this.onTakeShotClick.bind(this);
        this.onFullscreenCollapseClick = this.onFullscreenCollapseClick.bind(this);

        this.onClick = this.onClick.bind(this);
        this.onCloseClick = this.onCloseClick.bind(this);
        this.updateResolution = this.updateResolution.bind(this);
    }

    onClick(event) {
        if (this.state.fullscreen) {
            let clickedOutsideVideo = (event.target == this.videoContainer) || (event.target == this.pausedImg.parentNode);

            if (clickedOutsideVideo) this.collapse();
        }
    }

    onCloseClick() {
        this.props.dispatch({type: 'MY_VIDEO_WINDOW_TOGGLE'});
    }

    onMicClick(event) {
        let {currentUser} = this.props;

        if (currentUser.isAnonymous()) {
            // todo: show AnonymousLoginPopup here
            return false;
        }

        var target = event.target;

        let {dispatch} = this.props;

        if (target.className.indexOf('enabled') != -1) {
            dispatch({type: 'MY_VIDEO_WINDOW_DISABLE_SOUND'})
        } else {
            dispatch({type: 'MY_VIDEO_WINDOW_ENABLE_SOUND'})
        }
    }
    
    onRecordClick = () => {
        let {currentUser} = this.props;
        if (!currentUser.isAnonymous() && !currentUser.isXXL()) {
            BecomeXXLPopup.open("feature");

            return false;
        }

        const {recording} = this.state;
        if (!recording) {
            this.setState({confirmRecord: true, whatToRecord: "video"});
        } else {
            this.startRecord();
        }
    }
    
    onConfirmClick = () => {
        this.setState({confirmRecord: false}, () => {
            this.startRecord();
        })
    }
    
    onCancelClick = () => {
        this.setState({confirmRecord: false});
    }

    startRecord = () => {
        let messageTimeout;
        let countdownTimeout;
        const {dispatch} = this.props;
        const lang = Registry.get('locale');
        const chatInterface = Registry.get('chatInterface');
        const {whatToRecord} = this.state;

        if (!this.state.recording) {
            let interval;
            this.setState({showCountdown: true}, () => {
                interval = setInterval(() => {
                    const {countdownValue} = this.state;
                    if (countdownValue >= 1) {
                        this.setState({countdownValue: countdownValue - 1 });
                    } else {
                        this.setState({countdownValue: 3 });
                        clearInterval(interval);
                    }
                }, 1000);
            });

            countdownTimeout = setTimeout(
                () => {
                    if (whatToRecord == "video") {
                        chatInterface.streamRecordStart(
                            ({max_length}) => {
                                this.setState({showCountdown: false, countdownValue: 3});
                                dispatch({type: 'MY_VIDEO_WINDOW_RECORD_START', max_length})
                            },
                            () => {
                                dispatch({type: 'MY_VIDEO_WINDOW_RECORD_STOP', message: lang.recordMessage});
                                messageTimeout = setTimeout(() => {
                                    this.clearMessage();
                                    clearTimeout(messageTimeout);
                                }, 5000)
                            },
                            (e) => {
                                console.log("error while trying to record video", e);
                            });
                    } else {
                        this.setState({showCountdown: false, countdownValue: 3});
                        

                        var videoImageData = chatInterface.mediaScreenshot(this.videoElement);
                        chatInterface.streamTakeShot(videoImageData,
                            () => {
                                this.clearMessage();
                                clearTimeout(messageTimeout);
                            });
                    }
                    clearTimeout(countdownTimeout);
                }, 3000);
        } else {
            chatInterface.streamRecordStop();
        }
    }

    clearMessage = () => {
        const {dispatch} = this.props;
        dispatch({type: 'MY_VIDEO_WINDOW_CLEAR_MESSAGE'});
    }
    
    postPauseScreenshot() {
        let chatInterface = Registry.get('chatInterface');

        var videoImageData = chatInterface.mediaScreenshot(this.videoElement);
        chatInterface.streamScreenshot(videoImageData);
        this.pausedImg.src = videoImageData;
    }

    onPauseClick(event) {
        var target = event.target;

        let {dispatch} = this.props;

        if (target.className.indexOf('pause') != -1) {
            dispatch({type: 'MY_VIDEO_WINDOW_PAUSE'})
        }

        if (target.className.indexOf('play') != -1) {
            dispatch({type: 'MY_VIDEO_WINDOW_UNPAUSE'})
        }
    }

    onTakeShotClick(event) {
        const {recording} = this.state;
        if (!recording) {
            this.setState({confirmRecord: true, whatToRecord: "photo"});
        }
    }

    onFullscreenCollapseClick(event) {
        let target = event.target;

        if (target.className == 'fullscreen') {
            this.fullscreen();
        }

        if (target.className == 'window') {
            this.collapse();
        }
    }

    collapse() {
        let {dispatch} = this.props;
        dispatch({type: 'MY_VIDEO_WINDOW_COLLAPSE'})
    }

    fullscreen() {
        let {dispatch} = this.props;
        dispatch({type: 'MY_VIDEO_WINDOW_FULLSCREEN'})
    }

    onVideoContextMenu(event) {
        event.preventDefault();
        return false;
    }

    beforeGoingFullscreen() {
        this.setState({
            savedLeft: this.videoWindowMine.current.style.left,
            savedTop: this.videoWindowMine.current.style.top
        });

        this.videoWindowMine.current.style.left = "0";
        this.videoWindowMine.current.style.top = "0";
        this.videoWindowMine.current.style.zIndex = "";

        this.onWindowResizeFullscreen();
    }

    beforeGoingWindow() {
        let {browser} = this.props;

        this.videoWindowMine.current.style.left = this.state.savedLeft;
        this.videoWindowMine.current.style.top = this.state.savedTop;

        if (browser.mobile) {
            this.videoContainer.style.top = "";
            this.videoContainer.style.width = "";
            this.videoContainer.style.height = "";
            this.videoContainer.style.transform = "";
        }

        // only my
        this.videoWindowMine.current.style.top = "";

        if (!browser.mobile) {
            this.videoWindowMine.current.style.left = this.state.savedLeft;
            this.videoWindowMine.current.style.top = this.state.savedTop;
        }
    }

    onWindowResizeFullscreen() {
        this.videoContainer.style.top = '50%';
        this.videoContainer.style.transform = 'translateY(-50%)';
    }

    componentDidMount() {
        let chatInterface = Registry.get('chatInterface');

        let {browser} = this.props;

        if (this.videoElement.srcObject != this.props.streamingStatus.stream) {
            this.videoElement.srcObject = this.props.streamingStatus.stream;
        }

        if (chatInterface.hitagi.media.setSnapshotVideoSource) {
            chatInterface.hitagi.media.setSnapshotVideoSource(this.videoElement);
        }

        if (browser.desktop) {
            var draggie = new Draggabilly(this.videoWindowMine.current, {
                handle: ".video",
                containment: document.body
            });
            
            VirtualWindowManager.register(this.videoWindowMine.current, false, draggie);
        }

        !browser.mobile ? this.videoWindowMine.current.addEventListener('mousemove', e => this.mouseMoveEvent()) : false;
        !browser.mobile ? this.videoWindowMine.current.addEventListener('mouseleave', e => this.mouseLeaveEvent()) : false;

        this.videoElement.addEventListener('loadeddata', e => this.updateResolution());
        this.updateResolutionInterval = window.setInterval(this.updateResolution, 10000);

    }

    updateResolution() {
        let {streamingStatus} = this.props;

        if(streamingStatus.stream) {
            let media_stream_track = streamingStatus.stream.getVideoTracks()[0]; //MediaStreamTrack

            if( (media_stream_track instanceof MediaStreamTrack) && (typeof media_stream_track.getSettings === "function") ) {
                let videostream_settings = media_stream_track.getSettings();

                if (videostream_settings.width && videostream_settings.height) {
                    let resolution = videostream_settings.width + "x" + videostream_settings.height;
                    //console.log("resolution:", resolution);
                    if (this.state.resolution !== resolution) {
                        this.setState({ resolution });
                    }
                }
            }
        }
    }

    mouseMoveEvent() {
        const {confirmRecord} = this.state;
        if (confirmRecord) return;
        
        clearTimeout(this.timerMouseMove);

        this.videoWindowMine.current.classList.add('showControls');
        !this.state.fullscreen && this.videoWindowMine.current.classList.add('showOverlay');

        this.timerMouseMove = setTimeout(() => this.mouseLeaveEvent(), 2000);
    }

    mouseLeaveEvent() {
        this.videoWindowMine.current.classList.remove('showControls', 'showOverlay');
    }

    componentWillReceiveProps(nextProps) {
        this.setState(nextProps.myVideoWindow);
    }

    componentWillUpdate(nextProps, nextState) {
        let chatInterface = Registry.get('chatInterface');

        // todo: may be store subscriber in chatinterface-redux binding?
        if (this.state.sound && !nextState.sound) {
            chatInterface.mute();
        } else if (!this.state.sound && nextState.sound) {
            chatInterface.talk();
        }

        if (this.state.paused && !nextState.paused) {
            chatInterface.mediaPlay();
        } else if (!this.state.paused && nextState.paused) {
            this.postPauseScreenshot();
            chatInterface.mediaPause();
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (!prevState.fullscreen && this.state.fullscreen) {
            this.beforeGoingFullscreen();
        }

        if (prevState.fullscreen && !this.state.fullscreen) {
            this.beforeGoingWindow();
        }

        if (prevState.fullscreen && this.state.fullscreen && prevProps.browser.landscape != this.props.browser.landscape) {
            this.onWindowResizeFullscreen();
        }

        if (this.videoElement.srcObject != this.props.streamingStatus.stream) {
            this.videoElement.srcObject = this.props.streamingStatus.stream;
        }
    }

    componentWillUnmount() {
        if (this.updateResolutionInterval) {
            window.clearInterval(this.updateResolutionInterval);
        }
    }

    render() {
        let lang = Registry.get('locale');
        const {message, fullscreen, showCountdown, countdownValue, paused, error, confirmRecord} = this.state;
        const {currentUser, streamingStatus, watchingMeCount, browser} = this.props;
        let cssClasses = ['block-mystream', 'popup-video'];

        if (fullscreen) {
            cssClasses.push('fullscreen');
        } else {
            cssClasses.push('window');
            cssClasses.push('small');
            cssClasses.push('virtual-window');
        }

        if (!this.state.shown) cssClasses.push('hidden');
        if (this.state.paused) cssClasses.push('paused');
        if (streamingStatus.status === STREAMING_ERROR) cssClasses.push('failed');
    
        const pauseButtonClasses = ['toggle'];
        if (paused) {
            pauseButtonClasses.push('play');
        } else {
            pauseButtonClasses.push('pause');
        }
        if (this.state.recording || showCountdown) {
            pauseButtonClasses.push('disabled');
        }
        
        const messageClasses = ['record-message'];
        if (browser.mobile) messageClasses.push('mobile');
        if (error) messageClasses.push('error');
    
        this.videoWindowMine = React.createRef();

        let showProfileButton = false;
        let showTakeShotButton = false;

        let confirmRecordText = this.state.whatToRecord == "video" ? lang.confirmRecordText : lang.confirmPhotoText;
        return (
            <div className={cssClasses.join(' ')} ref={this.videoWindowMine} onClick={this.onClick}>
                <div className="video" ref={(ref) => this.videoContainer = ref}>
                    {!browser.mobile ? <div className="background-dark"/> : null}
                    {showCountdown && <div className="background-dark countdown">{countdownValue}</div>}
                    <div className="top" style={{opacity: 1}}>
                        <div className="fono" />
                        <div className="counter">
                            <span className="eye" />
                            <span className="count">{watchingMeCount}</span>
                        </div>
                        <div className="text fade-effect">
                            <span className="nick">{currentUser.nick}</span>
                        </div>
                        <div className="close fade-effect" onClick={this.onCloseClick} />
                    </div>
                    {this.state.resolution && <div className="res fade-effect">{this.state.resolution}</div>}
                    <div className="stub-block failed-stub">
                        <span className="stub-block-text failed-text" dangerouslySetInnerHTML={{__html:lang.failed_streaming}}/>
                    </div>
                    <div className="stub-block paused-stub">
                        <span className="stub-block-text paused-text">{lang.message_video_paused}</span>
                        <div className="paused-img"><img ref={(pausedImg) => this.pausedImg = pausedImg}/></div>
                    </div>
                    <video
                        muted={true}
                        autoPlay="autoplay"
                        playsInline={true}
                        onContextMenu={this.onVideoContextMenu}
                        ref={(videoElement) => this.videoElement = videoElement}
                    />
                    {message &&
                        <div className={messageClasses.join(' ')} onClick={this.clearMessage}>
                            {message}
                        </div>
                    }
                    {confirmRecord &&
                        <div className="confirm-dialog">
                            <div className="text">
                                {confirmRecordText}
                            </div>
                            <div className="buttons">
                                <button className="confirm" onClick={this.onConfirmClick}>{lang.confirm}</button>
                                <button className="cancel" onClick={this.onCancelClick}>{lang.cancel}</button>
                            </div>
                        </div>
                    }
                    {(((!message || fullscreen) && browser.mobile) || !browser.mobile) && (
                        <div className="icon-mystream fade-effect-inner">
                            <RecordButton recording={this.state.recording} onRecordClick={this.onRecordClick} />
                            {showTakeShotButton && <span className='take-shot' onClick={this.onTakeShotClick}></span>}
                            <span className={'mic' + (this.state.sound ? ' enabled' : '')} onClick={this.onMicClick} />
                            <span className={pauseButtonClasses.join(' ')} onClick={this.onPauseClick} />
                            {showProfileButton && <a href={lang.path + '/membre'} target="_blank" className="profile" />}
                            <span className={fullscreen ? 'window' : 'fullscreen'} onClick={this.onFullscreenCollapseClick} />
                        </div>
                    )}
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    let room = state.rooms[state.visibleChatrooms.roomid];
    let watcherCount = {};
    if (room) {
        watcherCount = room.watcherCount;
    }

    return {
        currentUser: state.currentUser,
        streamingStatus: state.streamingStatus,
        myVideoWindow: state.myVideoWindow,
        watchingMe: state.watchingMe,
        watchingMeCount: state.currentUser.ufrag ? (watcherCount[state.currentUser.ufrag] || 0) : 0,
        browser: state.browser
    }
}

export default connect(mapStateToProps)(VideoWindowMine);


// WEBPACK FOOTER //
// ./src/components/bobtv-neo/VideoWindowMine/index.js